import { Component } from '@angular/core';
import { DateTimeService } from '../../utilities/date-time.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  constructor(private datetimeService: DateTimeService) { }

  get copyrightYear() {
    return this.datetimeService.getCurrentTime().format('YYYY');
  }
}
